// outbox-rules.js — 2026-09-15 — pure rules the drain applies (node-tested).
// ---------------------------------------------------------------------------
// Brett: "deleting photos is hit and miss. Its like i need to do it twice
// before it gets removed." Two of the reasons were in the drain:
//
//   * a DELETE the server answered 404 was quarantined as "refused", although
//     what it asked for — the photo gone — was already true;
//   * a drain asked for while one was running got the running one back, and
//     that one had read the queue before the new change was added, so a removed
//     photo's DELETE sat unsent until something else started a drain.
//
// The drain itself needs IndexedDB and fetch; the decisions are here so they
// can be tested on their own.
// ---------------------------------------------------------------------------

// A DELETE answered 404 has done its job: the thing is gone (removed twice, or
// by someone else). Only DELETE — a refused upload still holds the only copy of
// a photo taken on site, and a refused edit is work the user must see.
export function refusalMeansDone(method, status) {
  return String(method || '').toUpperCase() === 'DELETE' && Number(status) === 404;
}

// Two passes of the drain reported as one. Counts of work done add up; what is
// left (remaining, blocked, stopped, held) is the later pass's, because that
// pass read the queue last.
export function mergeDrainResults(a, b) {
  if (!a) return b;
  if (!b) return a;
  return {
    ...b,
    drained: (a.drained || 0) + (b.drained || 0),
    applied: [...(a.applied || []), ...(b.applied || [])],
    rejected: [...(a.rejected || []), ...(b.rejected || [])],
  };
}
